import React from 'react';
import styles from '~/src/lib/styles.json';
import './FooterLinks.scss';

const FooterLinks = ({ children }) => (
	<div
		className={'FooterLinks'}
		style={{
			display: 'flex',
			flexDirection: 'row',
			flexWrap: 'wrap',
			justifyContent: 'space-evenly',
			gap: styles.SIZE.GAP,
			alignItems: 'center',
			maxWidth: '100%',
		}}
	>
		{children}
	</div>
);

export default FooterLinks;
